@for(option of options; track option) {
    <label>
        <span>{{ 'shopping_as.'+option | uppercase | translate }}</span>
        <input  type="radio"
                name="shop-as"
                [value]="option"
                (input)="type.emit($event.target.value)"
                [checked]="initial === option">
    </label>
}
